import { createStyles } from '@material-ui/core';
export default createStyles({
    root: {
        marginTop: '0',
        marginBottom: '0',
    },
});
